import React from 'react'

const conduitData = [
	{ code: 'APC101', desc: 'PVC Conduit 20mm' },
	{ code: 'APC102', desc: 'PVC Conduit 25mm' },
	{ code: 'APC103', desc: 'PVC Conduit 32mm' },
	{ code: 'APC104', desc: 'PVC Conduit 40mm' },
	{ code: 'APC105', desc: 'PVC Conduit 50mm' },
	{ code: 'APC106', desc: 'PVC Conduit 110mm' },
]

const trunkingData = [
	{ code: 'APT001', desc: 'Trunking 16x16' },
	{ code: 'APT002', desc: 'Trunking 16x25' },
	{ code: 'APT003', desc: 'Trunking 25x25' },
	{ code: 'APT004', desc: 'Trunking 40x16' },
	{ code: 'APT005', desc: 'Trunking 40x25' },
	{ code: 'APT006', desc: 'Trunking 40x40' },
	{ code: 'APT007', desc: 'Trunking 50x50' },
	{ code: 'APT008', desc: 'Trunking 75x50' },
	{ code: 'APT009', desc: 'Trunking 75x75' },
	{ code: 'APT010', desc: 'Trunking 100x40' },
	{ code: 'APT011', desc: 'Trunking 100x50' },
	{ code: 'APT012', desc: 'Trunking 100x100' },
]

export const PVC = () => {
	return (
		<div className='grid grid-cols-1 lg:grid-cols-2 gap-8'>
			{/* PVC CONDUIT TABLE */}
			<div className='overflow-hidden rounded-2xl border border-slate-900 shadow-lg bg-white'>
				<div className='bg-slate-900 text-white px-6 py-3.5 border-b-4 border-red-600 flex justify-between items-center'>
					<h3 className='font-heading font-bold uppercase tracking-wider text-sm'>
						PVC Conduit Range
					</h3>
					<span className='text-[10px] bg-red-600 text-white font-bold px-2.5 py-0.5 rounded-full uppercase tracking-wider'>
						SANS Approved
					</span>
				</div>
				<table className='w-full text-left font-sans text-sm'>
					<thead className='bg-slate-100 border-b border-slate-200 text-slate-800 font-bold text-xs uppercase tracking-wider'>
						<tr>
							<th className='px-6 py-3 w-1/3 border-r border-slate-200'>
								Code
							</th>
							<th className='px-6 py-3 w-2/3'>Description</th>
						</tr>
					</thead>
					<tbody className='divide-y divide-slate-200 font-medium text-slate-900'>
						{conduitData.map((row, idx) => (
							<tr
								key={row.code}
								className={idx % 2 === 0 ? 'bg-white' : 'bg-slate-50'}>
								<td className='px-6 py-2.5 border-r border-slate-200 font-bold text-red-600'>
									{row.code}
								</td>
								<td className='px-6 py-2.5 text-slate-800'>{row.desc}</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>

			{/* PVC TRUNKING TABLE */}
			<div className='overflow-hidden rounded-2xl border border-slate-900 shadow-lg bg-white'>
				<div className='bg-slate-900 text-white px-6 py-3.5 border-b-4 border-red-600 flex justify-between items-center'>
					<h3 className='font-heading font-bold uppercase tracking-wider text-sm'>
						PVC Trunking Range
					</h3>
					<span className='text-[10px] bg-red-600 text-white font-bold px-2.5 py-0.5 rounded-full uppercase tracking-wider'>
						Heavy Duty
					</span>
				</div>
				<table className='w-full text-left font-sans text-sm'>
					<thead className='bg-slate-100 border-b border-slate-200 text-slate-800 font-bold text-xs uppercase tracking-wider'>
						<tr>
							<th className='px-6 py-3 w-1/3 border-r border-slate-200'>
								Code
							</th>
							<th className='px-6 py-3 w-2/3'>Description</th>
						</tr>
					</thead>
					<tbody className='divide-y divide-slate-200 font-medium text-slate-900'>
						{trunkingData.map((row, idx) => (
							<tr
								key={row.code}
								className={idx % 2 === 0 ? 'bg-white' : 'bg-slate-50'}>
								<td className='px-6 py-2.5 border-r border-slate-200 font-bold text-red-600'>
									{row.code}
								</td>
								<td className='px-6 py-2.5 text-slate-800'>{row.desc}</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	)
}
